/**
 * @desc 获取所有的销售渠道
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SalesChannelRpcResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/salesChannel/getAll`, {
      method: "GET",

      ...options,
    }),
  );
}
